import ObjectsAPI from '../api/Objects';
import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';

export const setLastObjects = () => (dispatch) => {
    const requestParams = {
        embed: [ObjectConst.EMBED.IMAGES, ObjectConst.EMBED.TRANSLATES],
        order: 'CREATE_TIME'
    };

    ObjectsAPI.getObjects(requestParams)
        .then(({data: {rows}}) => {
            dispatch({
                type: ActionTypes.SET_LAST_OBJECTS,
                payload: rows
            });
        });
};


// WEBPACK FOOTER //
// ./src/actions/Home.js